import { IQuery } from 'core-ts-types';
import { IDatasource, Query } from 'utility-ts-orm';
import { TypeUtility } from 'utility-ts-type';
import {
  IContentTileActionObj,
  IContentTileExpectedObj,
  IContentTileIconObj,
  IContentTileTextObj
} from 'ui-ng-content-tile';
import { ReminderListDatastore } from '../datasources/personal_reminder_list_datasource';
import { IReminderData } from '../personal_reminder_interface';
import * as _4 from 'lodash4';

export class ReminderPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _count: number;

  constructor(
    private reminderListDatastore: ReminderListDatastore,
    private ngTypeUtility: typeof TypeUtility,
    private TaskStatusEnum: any
  ) {
    Query.registerQuery(this, this.reminderListDatastore);
  }

  run(): this {
    const endOfToday: moment.Moment = moment().endOf('day');
    const remindersDueToday = _4.filter(this.reminderListDatastore.read(), (reminder: IReminderData) => {
      if (this.isAllDayReminder(reminder)) {
        return (
          this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status)) &&
          moment(reminder.due_dt).isSame(moment(), 'day')
        );
      }
      return (
        this.TaskStatusEnum.isActive(this.TaskStatusEnum.get(reminder.status)) &&
        moment(reminder.due_ts as string).isAfter(moment.now()) &&
        moment(reminder.due_ts as string).isBefore(endOfToday)
      );
    });

    this._count = remindersDueToday.length;
    const isActive = remindersDueToday.length > 0;

    const singleReminderDueToday: IReminderData = _4.first(remindersDueToday);
    const text =
      remindersDueToday.length === 1
        ? { title: singleReminderDueToday.title, subTitle: this.getReminderDateTime(singleReminderDueToday) }
        : {
            title: `You have ${remindersDueToday.length} personal to-dos today`,
            subTitle: 'Check them out'
          };

    const action =
      remindersDueToday.length === 1
        ? { state: 'my.todos.reminder', params: { personalTodoID: singleReminderDueToday.id } }
        : { state: 'my.todos', params: { filterBy: 'reminders' } };

    this._result = {
      icon: { type: 'alarm_clock', theme: 'tertiary-3' },
      text,
      action,
      isOverdue: false,
      isActive
    };

    return this;
  }

  getReminderDateTime(reminder: IReminderData): string {
    const dateTime = moment(`${reminder.due_dt} ${reminder.due_tm}`);
    const noTime = dateTime.hours() === 0 && dateTime.minutes() === 0;
    const dueToday = moment().diff(dateTime, 'days') === 0;
    if (dueToday && noTime) {
      return 'Due today';
    }

    if (dueToday) {
      return `Due today at ${dateTime.format('h:mm a')}`;
    }

    if (noTime) {
      return `Due on ${this.ngTypeUtility.time.getWeekDayMonthDay(dateTime)}`;
    }

    return `Due on ${this.ngTypeUtility.time.getWeekDayMonthDay(dateTime)} at ${dateTime.format('h:mm a')}`;
  }

  private isAllDayReminder(reminder: IReminderData): boolean {
    const dateTime = moment(reminder.due_ts as string);
    return dateTime.hours() === 0 && dateTime.minutes() === 0;
  }

  get count() {
    return this._count;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/queries/reminder_priority_feed_query.ts